import { RemoteGetAllPersonProfile } from 'data/usecases';
import { GetAllPersonProfileUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPersonProfile } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllPersonProfile =
  (): GetAllPersonProfileUseCaseInterface =>
    new RemoteGetAllPersonProfile(
      makeApiUrlPersonProfile(),
      makeAxiosHttpClient(),
    );
